const drawerSelectors = {
    cartIcons: document.querySelectorAll('.header__icon--cart'),
    cartIconDesktop: document.querySelector('#cart-icon-desktop'),
    cartIconMobile: document.querySelector('#cart-icon-mobile'), 
    cartDrawerCount: document.querySelector('#cartCount')
};



Shopify.Cart = Shopify.Cart || {};
Shopify.Cart.GiftWrap = {};
Shopify.Cart.GiftWrap.processGiftWrappingForCartItem = async (id, validateCheckbox, cart = null, productPage = false) => {
    const processItems = (idInput, type, cartData, resolve) => {
        let updates = [],
            itemsResult;

        //Checks the current cart to see what exists or not and returns a integer value
        let subscriptionBoxes = window.globalVariables.cart.items
          .filter(({ product_type = "" }) => {
            const pt = String(product_type).toLowerCase();
            const isSubscription = pt.includes("subscription");
            if (type === "expedited-shipping") {
              // only subscriptions that do NOT include "hack"
              return isSubscription && !pt.includes("hack");
            }
            // otherwise: include all subscriptions
            return isSubscription;
          })
          .reduce((total, { quantity = 0 }) => total + quantity, 0);
        if (cartData) {
            let currentIWW = document.querySelector(`.items-with-${type}`)?.value;
            itemsResult = [];

            [].slice.call(document.querySelectorAll(`.subscription-${type} input[type="checkbox"]`)).map(gwc => {
                if (gwc.checked) {
                    itemsResult.push(gwc.id.replace(`${type}-checkbox-`, ''));
                }
            });


            itemsResult.length > 0
              ? updates[idInput.value] = subscriptionBoxes
              : updates[idInput.value] = 0;
            if (!currentIWW && itemsResult.length === 0) {
                resolve(false);
            } else {
                if (currentIWW) {
                    if (currentIWW.split(',').length === itemsResult.length) {
                        resolve(false);
                    }
                }
            }
        } else {
          let checkbox;
            if (type === 'expedited-shipping') {
              checkbox = document.querySelector(`[data-item-id="${type}-checkbox-"]`);
            }else{
              checkbox = document.querySelector(`#${type}-checkbox-${id}`);
            }
            if (!checkbox) {
                checkbox = document.querySelector(`#${type}-checkbox-`);
            }

            if (validateCheckbox && (checkbox?.checked)) {
              if(productPage && !checkbox?.dataset?.name?.includes('hack')) {
                updates[idInput.value] = subscriptionBoxes + 1;
              }
              else{
                updates[idInput.value] = subscriptionBoxes;
              }
              if(type === 'expedited-shipping'){
                itemsResult = ['true'];
              }
              else{
                itemsResult = ['']
              }
            } else {
                updates[idInput.value] = 0;
                itemsResult = [];
            }
        }

        return [updates, itemsResult]
    }

    return new Promise((resolve) => {
        const gwId = document.querySelector('.gift-wrapping-id');
        const esId = document.querySelector('.expedited-shipping-id');
        // const hpgwId = document.querySelector('.hackpack-wrapping-id');
        // const hpesId = document.querySelector('.hackpack-expedited-shipping-id');

        if ((gwId && gwId.value) || (esId && esId.value)) {

            let [updates, itemsWithWrapping] =
            processItems(gwId, 'gift-wrapping', cart, resolve);
                

            let [secondUpdates, itemsWithExpedited] =
            processItems(esId, 'expedited-shipping', cart, resolve);


            // let [thirdUpdates, itemsWithHackpackWrapping] =
            // processItems(hpgwId, 'hackpack-wrapping', cart, resolve);


            // let [fourthUpdates, itemsWithHackpackExpedited] =
            // processItems(hpesId, 'hackpack-expedited-shipping', cart, resolve);

            // const arrayUpdates = [updates, secondUpdates, thirdUpdates, fourthUpdates]
            // let combinedUpdates = {};

            // arrayUpdates.forEach(obj => {
            //   for (let key in obj) {
            //     if (combinedUpdates[key]) {
            //       combinedUpdates[key] += obj[key];  // Sum the values for the same key
            //     } else {
            //       combinedUpdates[key] = obj[key];  // Initialize the key with the first value
            //     }
            //   }
            // });

            const request = {
                method: 'POST',
                headers: new Headers({'Content-Type': 'application/json'}),
                body: JSON.stringify({
                    updates: Object.assign({}, {
                        ...updates,
                        ...secondUpdates
                    }),
                    attributes: {
                        "gift-wrapping": itemsWithWrapping.length > 0,
                        "gift-note": "",
                        'items-with-expedited-shipping':itemsWithExpedited.length > 0 ? true : ''
                    }
                })
            }
            fetch('/cart/update.js', request)
                .then((response) => response.json())
                .then((response) => {
                    [].slice.call(document.querySelectorAll('.items-with-gift-wrapping')).map(giww => {
                        giww.value = itemsWithWrapping.join(',');
                    });

                    [].slice.call(document.querySelectorAll('.items-with-expedited-shipping')).map(iwes => {
                        iwes.value = itemsWithExpedited.join(',');
                    });

                    // [].slice.call(document.querySelectorAll('.items-with-hackpack-wrapping')).map(hpgiww => {
                    //   hpgiww.value = itemsWithHackpackWrapping.join(',');
                    // });

                    // [].slice.call(document.querySelectorAll('.items-with-hackpack-expedited-shipping')).map(iwhpes => {
                    //   iwhpes.value = itemsWithHackpackExpedited.join(',');
                    // });


                    resolve(response);
                }).catch(() => {
                    resolve(false)
                });
        } else {
            resolve(false)
        }
    });
};

class ajaxCart extends HTMLElement {
    constructor() {
        super();

        this.openeBy = drawerSelectors.cartIcons;
        // True only once _updateCart has actually re-read [data-cartScriptJSON]. The
        // exceeds-limit check refuses to decide from an unrefreshed snapshot, because
        // clearing _exceeds_limit off stale item counts is what made the attribute
        // disappear intermittently.
        this._cartSnapshotFresh = false;
        this._exceedsInFlight = false;
        // Warm the add-on eligibility id-sets so shouldOffer() is ready by first render.
        if (window.AddonEligibility) window.AddonEligibility.ready();
        this.bindEvents();
        this.cartNoteInput();
        this.querySelectorAll('.close-ajax--cart').forEach(button => button.addEventListener('click', this.closeCartDrawer.bind(this)));

        if (window.globalVariables.template !== 'cart') {
            this.addAccessibilityAttributes(this.openeBy);
            this.getCartData('');
            // Back from checkout restores this page from the back/forward cache without re-running
            // the constructor, so the drawer and header count would show the pre-checkout cart.
            window.addEventListener('pageshow', (event) => {
                if (event.persisted) this.getCartData('');
            });
        } else {
            this.style.visibility = 'visible';
        }

        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }

    /**
     * Observe attribute of component
     *
     * @returns {array} Attributes to Observe
     */
    static get observedAttributes() {
        return ['updating'];
    }

    /**
     * To Perform operation when attribute is changed
     * Calls attributeChangedCallback() with params when attribute value is updated
     *
     * @param {string} name attribute name
     * @param {string} oldValue attribute Old value
     * @param {string} newValue attribute latest value
     */
    attributeChangedCallback(name, oldValue, newValue) {
        // called when one of attributes listed above is modified
        if (name == 'updating' && newValue == 'false') {
            this.updateEvents();
        }
    }

    /**
     * Add accessibility attributes to Open Drawer buttons
     *
     * @param {Node Array} openDrawerButtons Cart Icons
     */
    addAccessibilityAttributes(openDrawerButtons) {
        let _this = this;
        openDrawerButtons.forEach(element => {
            element.setAttribute('role', 'button');
            element.setAttribute('aria-expanded', false);
            element.setAttribute('aria-controls', _this.id);
        });
    }

    /**
     * Escape Click event to close drawer when focused within Cart Drawer
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.querySelector('.close-ajax--cart').dispatchEvent(new Event('click'));
    }

    /**
     * bind dclick and keyup event to Cart Icons
     * bind keyUp event to Cart drawer component
     * bind Other inside element events
     *
     */
    bindEvents() {
        if (window.globalVariables.template !== 'cart') {
            this.openeBy.forEach(cartBtn => cartBtn.addEventListener('click', this.openCartDrawer.bind(this)));
            this.addEventListener('keyup', this.onKeyUp.bind(this));
        }
        this.updateEvents();
    }

    /**
     * bind Other inside element events to DOM
     *
     */
    updateEvents() {
        this.querySelectorAll('[data-itemRemove]').forEach(button => button.addEventListener('click', this.removeItem.bind(this)));
        this.querySelectorAll('[data-qty-btn]').forEach(button => button.addEventListener('click', this.manageQtyBtn.bind(this)));
        this.querySelectorAll('[data-qty-input]').forEach(button => button.addEventListener('change', this.onQtyChange.bind(this)));
        // this.giftWrapping();
        this.giftWrappingAll();
        
        this.expeditedShipping();
    }

    /**
     * Open Cart drawer and add focus to drawer container
     *
     * @param {event} Event instance
     */
    openCartDrawer(event) {
        if (!window.globalVariables.cart_drawer) {
            window.location.href = window.routes.cart_fetch_url || '/cart';
            return;
        }

        if (document.querySelector('#mobile-menu-drawer').classList.contains('opened-drawer')) {
            document.querySelector('.close-mobile--navbar').dispatchEvent(new Event('click'));
        }

        this.classList.add('opened-drawer');
        siteOverlay.prototype.showOverlay();
        Utility.forceFocus(this.querySelector('.cart-title'));
        let closeBtn = this.querySelector('.close-ajax--cart');
        Utility.trapFocus(this, closeBtn);

        if (event) {
            event.preventDefault();
            let openBy = event.currentTarget;
            openBy.setAttribute('aria-expanded', true);
        }
    }

    /**
     * Close Cart drawer and Remove focus from drawer container
     *
     * @param {event} Event instance
     */
    closeCartDrawer(event, elementToFocus = false) {
        if (event !== undefined) {
            event.preventDefault();
            this.classList.remove('opened-drawer');
            siteOverlay.prototype.hideOverlay();
            let openByEle = event.currentTarget;
            openByEle.setAttribute('aria-expanded', false);
            Utility.removeTrapFocus(elementToFocus);

            let actionBtn = drawerSelectors.cartIconDesktop;
            if (window.innerWidth < 1024) {
                actionBtn = drawerSelectors.cartIconMobile;
            }
            Utility.forceFocus(actionBtn);
        }
    }

    /**
     * 
     * Replacement Parts Checker
     */

    async _addExceedsLimitProperty(limit = 4) {
      // Decide from a cart we know is current. A stale snapshot could show fewer parts
      // than the cart really holds, which made the clear branch below wipe a correctly
      // set _exceeds_limit. Falls back to /cart.js whenever _updateCart did not manage
      // to re-read [data-cartScriptJSON].
      let cart = window.globalVariables?.cart;
      if (!this._cartSnapshotFresh || !Array.isArray(cart?.items)) {
        cart = await fetch('/cart.js').then((response) => response.json());
        window.globalVariables.cart = cart;
        this._cartSnapshotFresh = true;
      }

      // One bucket per request group (the _replacement_parts value is the request
      // form's data-title, so all parts for a box share a key).
      const buckets = {};
      cart.items.forEach((item) => {
        const group = item.properties && item.properties['_replacement_parts'];
        if (group && item.product_type === 'Replacement Parts') {
          buckets[group] = (buckets[group] || 0) + (item.quantity || 1);
        }
      });
      const desired = Object.values(buckets).some((count) => count > limit);

      // Nothing to do when the cart already says what we want. This alone removes most
      // redundant writes, since the re-entrant getCartData() chains recompute the same
      // answer. Shopify stores attributes as strings, so accept either form.
      const current = (cart.attributes || {})['_exceeds_limit'];
      const isSet = current === true || current === 'true';
      const exists = current !== undefined && current !== null && current !== '';
      if (desired === isSet && (desired || !exists)) return;

      // Serialise overlapping chains so two /cart/update.js writes cannot race.
      if (this._exceedsInFlight) return;
      this._exceedsInFlight = true;
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { '_exceeds_limit': desired ? 'true' : '' } })
        });
        if (!response.ok) throw new Error(`cart/update.js ${response.status}`);
        // Keep the snapshot authoritative so the next call short-circuits above.
        window.globalVariables.cart = await response.json();
      } catch (e) {
        console.warn('[exceedsLimit]', e);
      } finally {
        this._exceedsInFlight = false;
      }
    }



_validateOrphans() {
    const cart = window.globalVariables.cart;
    if (!cart || !cart.items) return;

    // FIX 1: Convert mapped IDs to String()
    const attachedParentIds = cart.items
        .filter(item => item.properties && item.properties['_attached_id'] && !item.properties['_attached_product'])
        .map(item => String(item.properties['_attached_id'])); 

    // FIX 2: Convert mapped Bundle IDs to String()
    const bundleParentIds = cart.items
        .filter(item => item.properties && item.properties['_bundle_id'] && !item.properties['_bundled_product'])
        .map(item => String(item.properties['_bundle_id']));

    const updates = {};
    let hasOrphans = false;

    cart.items.forEach(item => {
        let reason = null;

        if (item.properties && (item.properties['_attached_product'] === 'true' || item.properties['_attached_product'] === true)) {
            // FIX 3: Convert the current item's attached_id to String()
            const pid = item.properties['_attached_id'] ? String(item.properties['_attached_id']) : null;
            if (!pid || !attachedParentIds.includes(pid)) {
                reason = "Missing Attached Parent";
            }
        }

        if (!reason && item.properties && (item.properties['_bundled_product'] === 'true' || item.properties['_bundled_product'] === true)) {
            // FIX 4: Convert the current item's bundle_id to String()
            const pid = item.properties['_bundle_id'] ? String(item.properties['_bundle_id']) : null;
            if (!pid || !bundleParentIds.includes(pid)) {
                reason = "Missing Bundle Parent";
            }
        }

        if (reason) {
            updates[item.key] = 0;
            hasOrphans = true;
        }
    });

    // 3. Execute Merge
    if (hasOrphans) {
        
        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
        })
        .then(response => response.json())
        .then(() => {
            // Explicit '' so _updateCart treats this as a plain refresh; passing no
            // action made it also run the gift-wrap pass and re-enter getCartData.
            this.getCartData('');
        })
        .catch(e => console.error('Error removing orphans', e));
    } else {
    }
}
    /**
     * Update cart HTML and Trigger Open Drawer event
     *
     * @param {string} cartHTML String formatted response from fetch cart.js call
     * @param {string} action Open Drawer as value if need to Open Cart drawer
     */
    _updateCart(response, action) {
        this.setAttribute('updating', true);
        // Convert the HTML string into a document object
        let cartHTML = '';
        if (window.globalVariables.template !== 'cart') {
            cartHTML = response['template-cart-drawer'];
        } else {
            cartHTML = response['template-cart'];
        }
        if (!cartHTML) return;

        let parser = new DOMParser();
        cartHTML = parser.parseFromString(cartHTML, 'text/html');

        let cartJSONEle = cartHTML.querySelector('[data-cartScriptJSON]');

        // Record whether the snapshot was actually refreshed — _addExceedsLimitProperty
        // refuses to decide from stale data and re-fetches /cart.js when this is false.
        this._cartSnapshotFresh = !!cartJSONEle;
        if (cartJSONEle) {
            window.globalVariables.cart = JSON.parse(cartJSONEle.textContent);
        }
        let cartElement = cartHTML.querySelector('ajax-cart form');
        let liveForm = this.querySelector('form');
        if (liveForm && cartElement) {
            liveForm.innerHTML = cartElement.innerHTML;
        } else {
            console.warn('[updateCart] missing form or cartElement; skipped HTML swap');
        }
        try{
          this.querySelector('[data-carttotal] span.money').innerHTML = Shopify.formatMoney(window.globalVariables.cart.total_price, window.globalVariables.money_format);
        }catch{}

        let elements = this.querySelectorAll('[data-checkoutBtns], [data-cartnote]');
        if (window.globalVariables.cart.item_count <= 0) {
            elements.forEach((div) => {
                div.classList.add('d-none');
            });
        } else {
            elements.forEach((div) => {
                div.classList.remove('d-none');
            });
        }
        this.setAttribute('updating', false);

        let headerHTML = new DOMParser().parseFromString(response['header'], 'text/html');
        let cartIcon = headerHTML.getElementById('cart-icon-desktop');
        let cartCount = headerHTML.getElementsByClassName('cart-count');

        if (drawerSelectors.cartIconDesktop) drawerSelectors.cartIconDesktop.innerHTML = cartIcon.innerHTML;
        if (drawerSelectors.cartIconMobile) drawerSelectors.cartIconMobile.innerHTML = cartIcon.innerHTML;
        if (drawerSelectors.cartDrawerCount) drawerSelectors.cartDrawerCount.innerHTML = cartCount[0].innerHTML;

        let limitEnable = window.subscriptions.enable_sub_limit;
        if (limitEnable && window.globalVariables.templateSuffix === 'subscription') {
            let cartDetails = window.globalVariables.cart;
            let quantityCount = 0;
            cartDetails.items.forEach(item => {
                if (item.product_type == "Build a Box Subscription") {
                    quantityCount = quantityCount + item.quantity;
                }
            });

            let limitRange = window.subscriptions.product_limit;
            if (quantityCount < limitRange) {
                document.querySelectorAll(".subscription_limit_error_msg").forEach(msg => {
                    msg.classList.add("d-none");
                });
            }
        }


        const giftWrappingElement = document.querySelector('ajax-cart .subscription-gift-wrapping');
        const expeditedShippingElement = document.querySelector('ajax-cart .subscription-expedited-shipping');

        // Show/hide the cart + drawer add-on checkboxes. The DECISION comes from the
        // collection-driven source of truth (AddonEligibility); if the module isn't
        // loaded, the checkboxes keep their server-rendered state.
        const applyCartAddonVisibility = (showDiscreet, showExpedited) => {
            if (giftWrappingElement) {
                if (!showDiscreet) {
                    giftWrappingElement.classList.remove('d-flex');
                    giftWrappingElement.classList.add('d-none');
                    const gwCheckbox = giftWrappingElement.querySelector('input[type="checkbox"]');
                    if (gwCheckbox && gwCheckbox.checked) {
                        gwCheckbox.checked = false;
                        gwCheckbox.dispatchEvent(new Event('change'));
                    }
                } else {
                    giftWrappingElement.classList.add('d-flex');
                    giftWrappingElement.classList.remove('d-none');
                }
            }

            if (expeditedShippingElement) {
                if (!showExpedited) {
                    expeditedShippingElement.classList.add('d-none');
                    const esCheckbox = expeditedShippingElement.querySelector('input[type="checkbox"]');
                    if (esCheckbox && esCheckbox.checked) {
                        esCheckbox.checked = false;
                        esCheckbox.dispatchEvent(new Event('change'));
                    }
                } else {
                    expeditedShippingElement.classList.remove('d-none');
                }
            }
        };

        if (window.AddonEligibility) {
            const cartItems = window.globalVariables.cart.items;
            window.AddonEligibility.ready().then(() => {
                applyCartAddonVisibility(
                    window.AddonEligibility.shouldOffer(cartItems, 'discreet'),
                    window.AddonEligibility.shouldOffer(cartItems, 'expedited')
                );
            });
        }

        // Subscription-page pseudo-checkbox visibility is owned by the funnel's
        // eligibility-driven _updateAddonPseudoVisibility(); re-run it on cart render.
        // (No-op on pages without the funnel.)
        if (typeof window.updateAddonPseudoVisibility === 'function') {
            window.updateAddonPseudoVisibility();
        }
        if (window.globalVariables.cart_drawer && action === 'open_drawer' && window.globalVariables.template !== 'cart') {
            this.openCartDrawer();
        }

        
        // Shopify.Cart.GiftWrap.processGiftWrappingForCartItem(0, true, response);
        if (action !== '') {
          Shopify.Cart.GiftWrap.processGiftWrappingForCartItem(0, true, response).then((updatedResponse) => {
              if (updatedResponse) {
                  this.getCartData('sync_update'); 
              }
          });
      }
    }

    /**
     * Fetch latest cart data
     *
     * @param {string} action Open Drawer as value if need to Open Cart drawer or else let it be empty
     */
    getCartData(action) {
        const fetchSection = window.globalVariables.template !== 'cart' ? 'template-cart-drawer' : 'template-cart';
        // no-store: the sections response is cacheable (ETag, no Cache-Control), and Back/Forward
        // navigations prefer the HTTP cache, so this would otherwise repaint a pre-checkout cart.
        return fetch(`${routes.cart_fetch_url}?sections=${fetchSection},header`, { cache: 'no-store' })
            .then(response => {
                return response.json();
            }).then(response => {
                // Contained so a render failure here no longer skips both checks below.
                try { this._updateCart(response, action); }
                catch (e) { console.warn('[updateCart]', e); }
            }).then(() => {
                // Awaited: the attribute write used to be fire-and-forget, so a later
                // chain could read a cart from before it landed.
                return this._addExceedsLimitProperty();
            }).then(() => {
                this._validateOrphans();
            }).catch((e) => {
                console.warn('[getCartData]', e);
            });
    }

    /**
     * Update Quantity API call
     *
     * @param {string} line Line Index value of cart Item (Starts from 1)
     * @param {integer} quantity Quantity to update
     */
    updateItemQty(line, quantity, removing = false, target = null) {
        let lineItem = document.querySelectorAll('[data-cart-item]')[line - 1];
        let itemType = target?.dataset?.itemType?.includes('Subscription') || false;
        if(removing && itemType) {
          let itemId = parseInt(target.dataset.itemId);
          let updates = {};
          let attributes = {};
          let getWrapQty;
          updates[itemId] = 0;

          if(itemType === true){
            let giftWrappingId = parseInt(document.querySelector('input.gift-wrapping-id').value);
            if(!Number.isNaN(giftWrappingId)){
              getWrapQty = window.globalVariables.cart.items.find(item => item.id === giftWrappingId)?.quantity || null;
              updates[giftWrappingId] = getWrapQty - 1;
              if(getWrapQty - 1 === 0){
                attributes['gift-wrapping'] = "false"
              }
              if(getWrapQty === null) {
                updates[giftWrappingId] = 0;
                attributes['gift-wrapping'] = 'false'
              }
            }
          } 
                    
            let expeditedId = parseInt(document.querySelector('.expedited-shipping-id')?.value);
            if (!Number.isNaN(expeditedId)) {
                let getExpeditedQty = window.globalVariables.cart.items.find(item => item.id === expeditedId)?.quantity || null;
                
                if (getExpeditedQty !== null) {
                    updates[expeditedId] = getExpeditedQty - 1;

                    // If quantity drops to 0 or below, ensure we clear the attribute and set qty to 0
                    if (getExpeditedQty - 1 <= 0) {
                        attributes['items-with-expedited-shipping'] = ""; // Clear the attribute
                        updates[expeditedId] = 0;
                    }
                }
            }


          if (lineItem) {
            lineItem.classList.add('updating');
          }

          const body = JSON.stringify({ updates, attributes });

          fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}})
            .then((response) => {
              return response.text();
            })
            .then((state) => {
              this.getCartData()
            })
            .then((data) => {
              // getWrapQty - 1 === 0 || getWrapQty === null
              //   ? document.querySelector('.subscription-gift-wrapping').classList.add('d-none')
              //   : null
              console.log('cart data')
            })
            .catch((error) => {
              console.log(error, 'error')
            })
        }
        else{
          if (lineItem) {
            lineItem.classList.add('updating');
          }
          const body = JSON.stringify({
              line,
              quantity
          });
          fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{body}})
              .then((response) => {
                  return response.text();
              })
              .then((state) => {
                  let jsonObj = JSON.parse(state);
                  this.getCartData('');

                  setTimeout(() => {
                      if (lineItem) {
                          lineItem.classList.remove('updating');
                      }
                  }, 1000);
              }).catch((error) => {
              setTimeout(() => {
                  if (lineItem) {
                      lineItem.classList.remove('updating');
                  }
              }, 1000);
              console.log(error);
          });
        }
    }

    /**
     * Remove Item Event
     *
     * @param {event} Event instance
     */
    removeItem(event) {
        const self = this;
        event.preventDefault();
        let currentTarget = event.currentTarget;
        let itemIndex = currentTarget.dataset.index || null;
        if (itemIndex != null) {
            self.updateItemQty(itemIndex, 0, true, currentTarget);
        }
    }

    /**
     * Cart Item Qunatity Increment/Decrement Button event
     *
     * @param {event} Event instance
     */
    manageQtyBtn(event) {
        event.preventDefault();
        let currentTarget = event.currentTarget;
        let action = currentTarget.dataset.for || 'increase';
        let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
        let itemIndex = $qtyInput.dataset.index || 1;
        let currentQty = parseInt($qtyInput.value) || 1;
        let finalQty = 1;

        if (action == 'decrease' && currentQty <= 1) {
            return false;
        } else if (action == 'decrease') {
            finalQty = currentQty - 1;
        } else {
            finalQty = currentQty + 1;
        }
        this.updateItemQty(itemIndex, finalQty);
    }

    /**
     * Cart Item Qunatity Input change event
     *
     * @param {event} Event instance
     */
    onQtyChange(event) {
        const $qtyInput = event.currentTarget;
        const qtyValue = $qtyInput.value;
        const itemIndex = $qtyInput.dataset.index || null;
        if (itemIndex) this.updateItemQty(itemIndex, qtyValue);
    }

    cartNoteInput() {
        const cartNoteEle = document.querySelector('[data-cartNote] [name="note"]');
        if (!cartNoteEle) return;

        const cartNoteSave = document.querySelector('[data-saveNote]');
        cartNoteEle.addEventListener("input", event => {
            cartNoteEle.value = cartNoteEle.value;
            const defaultNote = cartNoteEle.dataset.default;
            if (defaultNote != cartNoteEle.value) {
                cartNoteSave.style.display = 'block';
            } else {
                cartNoteSave.style.display = 'none';
            }
        }, false);
        cartNoteEle.addEventListener("paste", event => {
            cartNoteEle.value = cartNoteEle.value;
            const defaultNote = cartNoteEle.dataset.default;
            if (defaultNote != cartNoteEle.value) {
                cartNoteSave.style.display = 'block';
            } else {
                cartNoteSave.style.display = 'none';
            }
        }, false);

        //  Cart Note Change event
        cartNoteSave.addEventListener("click", e => {
            e.preventDefault();
            const currentTarget = e.currentTarget;
            const cartNoteContainer = currentTarget.closest('[data-cartNote]');
            const cartNote = cartNoteContainer.querySelector('[name="note"]').value.trim();
            if (cartNote.length <= 0) {
                alert('Add Note before proceeding');
                return;
            }
            const submitBtn = cartNoteContainer.querySelector('[data-saveNote]');
            const waitText = (submitBtn.dataset.adding_txt) ? submitBtn.dataset.adding_txt : 'Saving...';
            submitBtn.innerHTML = waitText;
            submitBtn.disabled = true;
            this.updateCartNote(cartNoteContainer);
        });
    }

    updateCartNote(cartNoteContainer) {
        const _this = this;
        const cartNoteEle = cartNoteContainer.querySelector('[name="note"]');
        const cartNote = cartNoteEle.value.trim();
        const resultEle = cartNoteContainer.querySelector('[data-resultMsg]');
        const submitBtn = cartNoteContainer.querySelector('[data-saveNote]');
        const defaultText = (submitBtn.dataset.default) ? submitBtn.dataset.default : 'Save';

        let body = JSON.stringify({
            note: cartNote
        });
        fetch(`${routes.cart_update_url}`, {
            ...fetchConfig(), ...{body}
        }).then(function (data) {
            if (data.status == 200) {
                if (resultEle) {
                    resultEle.innerText = 'Added note to Order!';
                    _this.manageResponseText(resultEle);
                }
                if (cartNoteEle) {
                    cartNoteEle.dataset.default = cartNote;
                }
                submitBtn.style.display = 'none';
                submitBtn.innerHTML = defaultText;
                submitBtn.disabled = false;
            } else {
                console.error('Request returned an error', data);
                if (resultEle) {
                    resultEle.innerText = data;
                    _this.manageResponseText(resultEle);
                }
                submitBtn.innerHTML = defaultText;
                submitBtn.disabled = false;
            }
        }).catch(function (error) {
            console.error('Request failed', error);
            if (resultEle) {
                resultEle.innerText = error;
                _this.manageResponseText(resultEle);
            }
            submitBtn.innerHTML = defaultText;
            submitBtn.disabled = false;
        });
    }

    manageResponseText(element) {
        Utility.fadeEffect(element, 'fadeIn');
        setTimeout(() => {
            Utility.fadeEffect(element, 'fadeOut');
        }, 3000);
    }

    giftWrapping() {
        const self = this;
        [].slice.call(document.querySelectorAll('.subscription-gift-wrapping:not(.evented)')).map(gw => {
            gw.classList.add('evented');
            window.globalVariables.gw_ip_enabled === 'true' ?
              window.country !== 'United States of America'
                ? gw?.classList.add('d-none')
                : null
              :null;
            const checkbox = gw.querySelector('input[type="checkbox"]');
            if (checkbox) {
                checkbox.addEventListener('change', () => {
                    const id = checkbox.id.replace('gift-wrapping-checkbox-', '');
                    if (id) {
                        Shopify.Cart.GiftWrap.processGiftWrappingForCartItem(id, true).then(() => {
                            self.getCartData('');
                        });
                    }
                });
            }
        });
    }

    giftWrappingAll() {
      const self = this;
      [].slice.call(document.querySelectorAll('.subscription-gift-wrapping:not(.evented)')).map(gw => {
        gw.classList.add('evented');
        window.globalVariables.gw_ip_enabled === 'true' ?
          window.country !== 'United States of America'
            ? gw?.classList.add('d-none')
            : null
          :null;
          
        const checkbox = gw.querySelector('input[type="checkbox"]');
        if (checkbox) {
            checkbox.addEventListener('change', (event) => {
              const id = 0;
              if(!event.target.closest('[data-product-container]')){
                Shopify.Cart.GiftWrap.processGiftWrappingForCartItem(id, true).then(() => {
                    self.getCartData('');
                });
              }
            });
        }
      });
    }

    expeditedShipping() {
        const self = this;
        [].slice.call(document.querySelectorAll('.subscription-expedited-shipping:not(.evented)')).map(es => {
            es.classList.add('evented');
            window.globalVariables.expedited_ip_enabled === 'true' ?
            window.country !== 'United States of America'
                ? es?.classList.add('d-none')
                : null
              : null;
            const checkbox = es.querySelector('input[type="checkbox"]');
            if (checkbox) {
                checkbox.addEventListener('change', () => {
                    const id = checkbox.dataset.itemId;
                    // mirror all instances for the same item
                    document
                      .querySelectorAll(`input.expedited-shipping-checkbox[data-item-id="${id}"]`)
                      .forEach(cb => { if (cb !== checkbox) cb.checked = checkbox.checked; });

                    Shopify.Cart.GiftWrap.processGiftWrappingForCartItem(id, true).then(() => {
                      self.getCartData('');
                    });
                });
            }
        });
    }

}

customElements.define("ajax-cart", ajaxCart);
  